import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { FC, useRef } from 'react'
import { SearchExpertisesLUT } from '../../../services/web/types/responseWebServiceTypes'
import Typography from '@material-ui/core/Typography'
import useTranslate from '../../../i18n/useTranslate'
import { ButtonView } from '../../../control/button/button'
import { useHistory } from 'react-router-dom'
import { RoutePath } from '../../../router/routesConfig'
import { useCommitteeStyles } from './committeeStyles'
import Dialog from '../../../control/dialog/dialog'
import { useForm } from 'react-final-form'
import { styled } from '@material-ui/styles'
import ExpertInfo from './ExpertInfo'
import ProjectInfo from './ProjectInfo'
import useCheckPermission from '../../../utilities/checkPermission'

const GreyCard = styled(Typography)({
    height: '32px',
    // width: '168px',
    minWidth: '168px',
    left: '0.0263671875px',
    top: '0px',
    borderRadius: '8px',
    background: '#757575',
    border: '1px solid #DCDCDC',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px',
    color: '#fff',
})

const PinkCard = styled(GreyCard)({
    background: '#db5f8e',
})

const DashText = styled(Typography)({
    marginLeft: '45px',
})

const SearchCommitteesResults: FC<{ searchResult: SearchExpertisesLUT[] }> = ({ searchResult }) => {
    const classes = useCommitteeStyles()

    const translate = useTranslate()
    const history = useHistory()
    const successRef = useRef<Record<string, Function>>()
    const form = useForm()
    const checkPermissionHook = useCheckPermission()

    const handleEdit = (id: number) => {
        /** EDIT */
        history.push(RoutePath.committeeEdit.replace(':id', `${id}`))
    }

    const bindSuccessRef = (func: Record<string, Function>) => {
        successRef.current = { ...func }
    }

    return (
        <>
            <Grid container justifyContent="space-between">
                <Grid item>
                    <Typography variant="h6">
                        {translate.get('LABEL.SEARCH_TOTAL_RESULT', [`${searchResult.length}`])}
                    </Typography>
                </Grid>
            </Grid>
            {searchResult.map((data: any) => (
                <Paper variant="outlined" className={classes.item} key={data.info.committeeID}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12}>
                            <Grid container spacing={2} alignItems="center" justifyContent="flex-end">
                                <Grid item>
                                    <ButtonView
                                        className={classes.btnEdit}
                                        onClick={() => handleEdit(data.info.committeeID)}
                                    >
                                        {checkPermissionHook.isUserChairman()
                                            ? translate.get('BUTTON.VIEW')
                                            : translate.get('BUTTON.EDIT')}
                                    </ButtonView>
                                </Grid>
                                <Grid item xs={true}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Typography variant="body2" className={classes.header}>
                                                {translate.get('LABEL.COMMITTEE_FULL_NAME')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="body2">
                                                {translate.languageStore.currentLanguage === translate.languageKey.th
                                                    ? data.info.nameTH
                                                    : data.info.nameEN}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item style={{ width: '182px' }}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Typography variant="body2" className={classes.header}>
                                                {translate.get('LABEL.EXPERTISE')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            {data.cntExpertise > 0 ? (
                                                <ExpertInfo committeeID={data.info.committeeID} />
                                            ) : (
                                                <DashText variant="body2">-</DashText>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item style={{ width: '200px' }}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Typography variant="body2" className={classes.header}>
                                                {translate.get('LABEL.IN_PROGRESS_PROJECT')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <ProjectInfo
                                                inProgress={data.inprogress}
                                                success={data.success}
                                                committeeID={data.info.committeeID}
                                                isInProgress={true}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item style={{ width: '200px' }}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Typography variant="body2" className={classes.header}>
                                                {translate.get('LABEL.FINISH_PROJECT')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <ProjectInfo
                                                inProgress={data.inprogress}
                                                success={data.success}
                                                committeeID={data.info.committeeID}
                                                isInProgress={false}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <ButtonView className={classes.btnEdit} style={{ visibility: 'hidden' }}>
                                &nbsp;
                            </ButtonView>
                        </Grid>
                        <Grid item xs={true}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant="body2" className={classes.header}>
                                        {translate.get('LABEL.NUMBER_OF_PROJECTS')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={1}>
                                        <Grid item>
                                            <GreyCard variant="body2">
                                                {translate.get('LABEL.DID_NOT_COMMENT', [`${data.noComment}`])}
                                            </GreyCard>
                                        </Grid>
                                        <Grid item>
                                            <PinkCard variant="body2">
                                                {translate.get('LABEL.DONE_COMMENT', [`${data.comment}`])}
                                            </PinkCard>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            ))}
            <Dialog
                onRef={bindSuccessRef}
                type="alert-message"
                title={translate.get('ALERT.TITLE.NOTIFICATION')}
                content={translate.get('ALERT.CONTENT.SAVE_SUCCESS')}
                onAfterClose={form.submit}
            />
        </>
    )
}

export default SearchCommitteesResults
